import React, {useRef} from "react";

import { Subscribe } from "unstated";

import { ProfileContainer } from "./containers/profile-container";
import { LoadingContainer } from "./containers/loading-container";

import { Form, Field } from "react-final-form";

import { FORM_ERROR } from "final-form";

import {
  required,
  nonEmptyString,
  email,
  dateOver21,
  phone,
  maxLength,
  composeField
} from "../lib/form-validators";
import { phoneFormatter, dateFormatter } from "../lib/form-formatters";
import { phoneParser, stringParser } from "../lib/form-parsers";

import { TextInput } from "../components/ui/text-input";
import { FormErrors } from "../components/ui/form-errors";
import toast from 'react-hot-toast';

import _ from "lodash";

import { AvatarUploader } from "./avatar-uploader";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import spacer from "../assets/images/spacer.png";



const ProfileUpdate = () => {
  const btnSubmitRef = useRef(null);
  const onSubmit = (profileContainer) => async (values) => {
    const params = _.pick(values, [
      "firstName",
      "lastName",
      "email",
      "dateOfBirth",
      "homePhoneNumber",
      "mobilePhoneNumber",
      "workPhoneNumber"
    ]);
    return profileContainer.updateProfile(params).then(()=>{
      if(btnSubmitRef && btnSubmitRef.current){
        btnSubmitRef.current.blur()
      }
      toast.success('Update profile successfully!!!')
    }).catch(() => {
      return { [FORM_ERROR]: "Failed to update Profile" };
    });
  };
  return (
    <Subscribe to={[ProfileContainer, LoadingContainer]}>
    {(profileContainer, loadingContainer) => {
      const currentProfile = profileContainer.getCurrentProfile();

      return (
        <div className="container p-2">
          <div className="row d-flex">
            <div className="col-md-6 px-5">
              {currentProfile && !_.isNil(currentProfile.avatarUrl) ? (
                <img className="img-fluid" src={currentProfile.avatarUrl} />
              ) : (
                <div className="dc-img_square bg-grey mb-3">
                  <img src={spacer} />
                  <div className="dc-img_square-icon text-muted">
                    <span className="fa-layers fa-4x">
                      <FontAwesomeIcon
                        className="avatar"
                        icon={["fas", "camera"]}
                      />
                    </span>
                  </div>
                </div>
              )}

              <div className="text-center mt-3">
                <AvatarUploader
                  profileContainer={profileContainer}
                  loadingContainer={loadingContainer}
                />
              </div>
            </div>

            <div className="col-md-6">
              <Form
                onSubmit={onSubmit(profileContainer)}
                initialValues={profileContainer.getCurrentProfile()}
                render={({
                  handleSubmit,
                  submitting,
                  submitError,
                  dirtySinceLastSubmit
                }) => (
                  <form id="updateProfile" onSubmit={handleSubmit}>
                    <Field
                      name="firstName"
                      parse={stringParser}
                      validate={composeField(nonEmptyString, maxLength(64))}
                      render={TextInput}
                      placeholder="First Name"
                      type="text"
                    />

                    <Field
                      name="lastName"
                      validate={composeField(nonEmptyString, maxLength(64))}
                      render={TextInput}
                      placeholder="Last Name"
                      type="text"
                    />

                    <Field
                      name="email"
                      parse={stringParser}
                      validate={composeField(
                        nonEmptyString,
                        email,
                        maxLength(256)
                      )}
                      render={TextInput}
                      placeholder="Email"
                      type="text"
                    />

                    <Field
                      name="dateOfBirth"
                      validate={composeField(required, dateOver21)}
                      formatOnBlur={true}
                      render={TextInput}
                      placeholder="Date of Birth"
                      format={dateFormatter}
                      type="date"
                      caption="* I am at least 21 years of age"
                    />

                    <Field
                      name="homePhoneNumber"
                      validate={composeField(phone)}
                      format={phoneFormatter}
                      parse={phoneParser}
                      formatOnChange={true}
                      render={TextInput}
                      placeholder="Home Phone Number"
                      type="tel"
                    />

                    <Field
                      name="mobilePhoneNumber"
                      format={phoneFormatter}
                      parse={phoneParser}
                      formatOnChange={true}
                      validate={composeField(phone)}
                      render={TextInput}
                      placeholder="Mobile Phone Number"
                      type="tel"
                    />

                    <Field
                      name="workPhoneNumber"
                      format={phoneFormatter}
                      parse={phoneParser}
                      formatOnChange={true}
                      validate={composeField(phone)}
                      render={TextInput}
                      placeholder="Work Phone Number"
                      type="tel"
                    />

                    <FormErrors
                      submitError={submitError}
                      dirtySinceLastSubmit={dirtySinceLastSubmit}
                    />
                  </form>
                )}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 text-center mt-4">
              <button ref={btnSubmitRef}
                className="btn btn-primary btn-wide"
                onClick={() =>
                  document
                    .getElementById("updateProfile")
                    .dispatchEvent(new Event("submit", { cancelable: true }))
                }>
                UPDATE
              </button>
            </div>
          </div>
        </div>
      );
    }}
  </Subscribe>
  )
};

export { ProfileUpdate };
